import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { EstadoNotificacionesDTO } from "app/main/apps/shared/interfaces/estado-notificaciones.interface";
import { UsuarioDTO } from "app/main/apps/shared/interfaces/usuario.interface";

@Component({
    selector: "app-notificaciones",
    templateUrl: "./notificaciones.component.html",
    styleUrls: ["./notificaciones.component.scss"],
})
export class NotificacionesComponent implements OnInit {
    @Input() perfilUsuario: UsuarioDTO;
    @Output() guardaConfNotificaciones: EventEmitter<
        number[]
    > = new EventEmitter();
    constructor() {}

    ngOnInit(): void {}

    toggleEstadoNotificacion(notificacion: EstadoNotificacionesDTO) {
        //console.log(notificacion);
        notificacion.activa = !notificacion.activa;
    }

    guardar() {
        //console.log(this.perfilUsuario.estadoNotificaciones);
        let notificacionesActivas: number[] = [];
        this.perfilUsuario.estadoNotificaciones.forEach((notificacion) => {
            if (notificacion.activa) {
                notificacionesActivas.push(notificacion.id);
            }
        });
        this.guardaConfNotificaciones.emit(notificacionesActivas);
    }
}
